<!-- Wrapper component using reusable action-confirmation-modal -->
@if (actionConfig) {
<gtw-action-confirmation-modal
 
  [config]="actionConfig"
  (confirmed)="onConfirmed()"
  (cancelled)="onCancelled()"
  (closed)="onClosed()">
</gtw-action-confirmation-modal>
}
